/**
 * MIDI Constants
 * Centralizes MIDI-related constants, ranges, and configuration values.
 */
export const MIDI_CONSTANTS = {
  ranges: {
    controllers: { min: 0, max: 127 },
    channels: { min: 0, max: 15 },
    notes: { min: 0, max: 127 },
    velocity: { min: 0, max: 127 },
    pitchBend: { min: 0, max: 16383 },
    programChange: { min: 0, max: 127 },
    aftertouch: { min: 0, max: 127 }
  },

  defaults: {
    channel: 0,
    velocity: 64,
    program: 0,
    controller: 1,
    note: 60,
    tempo: 120,
    division: 24
  },

  messageTypes: {
    noteOff: 0x80,
    noteOn: 0x90,
    aftertouch: 0xA0,
    controlChange: 0xB0,
    programChange: 0xC0,
    channelPressure: 0xD0,
    pitchBend: 0xE0,
    systemExclusive: 0xF0,
    midiClock: 0xF8,
    midiStart: 0xFA,
    midiContinue: 0xFB,
    midiStop: 0xFC
  },

  controllers: {
    modulation: 1,
    breath: 2,
    volume: 7,
    balance: 8,
    pan: 10,
    expression: 11,
    sustain: 64,
    portamento: 65,
    sostenuto: 66,
    softPedal: 67,
    filter: 74,
    resonance: 71,
    attack: 73,
    release: 72,
    allSoundOff: 120,
    resetControllers: 121,
    allNotesOff: 123
  },

  clock: {
    pulsesPerQuarterNote: 24,
    pulsesPerSixteenthNote: 6,
    pulsesPerEighthNote: 12,
    pulsesPerBar: 96,
    minTempo: 20,
    maxTempo: 300,
    defaultTempo: 120,
    clockTimeout: 1000,
    syncTolerance: 50
  },

  devices: {
    maxInputs: 16,
    maxOutputs: 16,
    connectionTimeout: 5000,
    reconnectDelay: 2000,
    maxReconnectAttempts: 3,
    devicePollInterval: 1000
  },

  mapping: {
    defaultMappingMode: 'absolute',
    relativeSensitivity: 1.0,
    accelerationCurve: 2.0,
    deadZone: 2,
    smoothingFactor: 0.1,
    quantizeThreshold: 8,
    maxMappings: 128,
    learningTimeout: 10000
  },

  notes: {
    names: ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'],
    middleC: 60,
    a440: 69,
    octaveSize: 12,
    lowestNote: 0,
    highestNote: 127
  },

  status: {
    connected: 'connected',
    disconnected: 'disconnected',
    error: 'error',
    learning: 'learning',
    mapping: 'mapping',
    syncing: 'syncing',
    ready: 'ready'
  },

  performance: {
    maxEventsPerFrame: 100,
    eventBufferSize: 1000,
    highResolutionTimer: true,
    priorityMessages: [0x90, 0x80, 0xB0],
    throttleInterval: 16,
    maxLatency: 20
  }
};
